const Profile = () => {

  if (THEME === 'cartablanca') {
    return (
      <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="25" cy="25.8652" r="24" stroke="white" strokeWidth="2" />
        <circle cx="25.0001" cy="20.1509" r="8.28571" stroke="white" strokeWidth="2" />
        <path d="M8.46216 43.2264C9.48736 35.0049 16.5007 28.6431 24.9999 28.6431C33.7369 28.6431 40.9037 35.3659 41.6095 43.9208" stroke="white" strokeWidth="2" />
      </svg>

    )
  }
  return (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17.5" cy="17.5" r="17" stroke="currentColor" />
      <circle cx="17.5001" cy="11.6668" r="5.33333" stroke="currentColor" />
      <path d="M5.92358 29.6527C6.64123 23.8976 11.5505 19.4443 17.5 19.4443C23.6159 19.4443 28.6327 24.1503 29.1267 30.1388" stroke="currentColor" />
    </svg>
  )
}

export default Profile;